import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式
import router from './router'
import store from './store'
import connectSocket from '@/utils/connectSocket'
import { queryLimit } from '@/api/base';
import i18n from './i18n'
const whiteList = ['/supervise/', '/supervise/404', '/supervise/detail', 
  '/supervise/wrong', '/supervise/noPermission'] // 不重定向白名单

import { getQueryString } from '@/utils'

// 初始化socket
function initSocket()
{
  if(window.isInitSocket)
  {
    return
  }
  try {
    const userInfo = {
      'teacher_id': sessionStorage.getItem('teacher_id'),
      'subject_id': sessionStorage.getItem('subject_id'),
      'school_id': sessionStorage.getItem('school_id'),
      'nick': sessionStorage.getItem('teacher_name'),
      'app_type': sessionStorage.getItem('app_type'), // (1: 线上, 2:线下）
      'refer_teacher_id': sessionStorage.getItem('refer_teacher_id'),
      'refer_school_id':sessionStorage.getItem('refer_school_id'),
      'user_type': sessionStorage.getItem('user_type'), // (1.学生 2.家长 3.校长 4.分析员 5.场务 6.课程顾问(CC)  7场控）
    }
    connectSocket(userInfo)
    window.isInitSocket =1


  } catch (e) {

  }
}

async function checkLimit (next, subjectId)  {
  const params = {
    subject_id: subjectId,
    route: '/supervise/home'
  };
  const { code, msg } = await queryLimit(params);
  if (+code === -9999991) {
    next({ path: 'noPermission', query: { reason: msg }, replace: true });
  }
}

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  if (to.query.token) {
    sessionStorage.clear()
    if (!sessionStorage.getItem('token')) {
      sessionStorage.setItem('token', to.query.token)
    }
    // 使用启蒙课程
    const appName = getQueryString('app_name') || '';
    if (appName) {
      sessionStorage.setItem('supervise_app_name', appName);
    }
    try {
      let res = await store.dispatch('Login', { token: to.query.token })
      if(!res){
        throw new Error()
        // 监课数据埋点
      } else {
        let { yx_token, subject_id, country_id } = res.data;
        if (!sessionStorage.getItem('yx_token')) {
          sessionStorage.setItem('yx_token', yx_token);
        }
        if(country_id){
          const country = country_id == 1 ? 'zh' : 'en';
          sessionStorage.setItem('Select-language',country);
          i18n.locale = country;
          if (country === 'en') {
            document.title = 'Squirrel Ai Learning';
          }
          store.dispatch('setLanguage',country)
        }
        checkLimit(next, subject_id);
        initSocket();
       // connectSocket(res.data)
      }
    } catch (e) {
      console.log({e})
      NProgress.done()
      return
    }
    next({ path: '/supervise/' })
  } else {
    // if (whiteList.indexOf(to.path) !== -1 && sessionStorage.getItem('token') !== null) {

    if (whiteList.indexOf(to.path) !== -1 ) {

          initSocket()

      next()
    } else {
      if (to.path != '/supervise/videoHandout' && to.path != '/supervise/viewVideo') {
        location.href = 'http://songshuai.com/'
        NProgress.done()
      } else {
        next()
      }
    }
  }

})


router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js